import {
  AUTHOR_PROFILE,
  ATTORNEY_DIRECTORY,
  ATTORNEY_PROFILE,
  CITY_PAGE,
  CONSUMER_REPORT,
  DONATIONS_PAGE,
  HOME_PAGE,
  LANDING_PAGE,
  LEARN_ARTICLE,
  STATE_PAGE,
} from './contentGroups';

export default {
  // 1 - Home Page
  [HOME_PAGE]: 'contentGroup1',
  // 2 - Landing/Generated Pages (w/e topic)
  [LANDING_PAGE]: 'contentGroup2',
  [CONSUMER_REPORT]: 'contentGroup2',
  [ATTORNEY_DIRECTORY]: 'contentGroup2',
  [ATTORNEY_PROFILE]: 'contentGroup2',
  // 3 - Written Content
  [LEARN_ARTICLE]: 'contentGroup3',
  [AUTHOR_PROFILE]: 'contentGroup3',
  // 4 - Localized Content
  [STATE_PAGE]: 'contentGroup4',
  [CITY_PAGE]: 'contentGroup4',
  // 5 - Donations/Impact
  [DONATIONS_PAGE]: 'contentGroup5',
};
